export default __webpack_public_path__ + "static/flowverse-477671eabc25f82b1be53609f733c2cd.png";